import React, { MouseEvent } from 'react';
import styled from 'styled-components';
import { SvgComponent, MedalGoldIcon } from '../../assets';
import { theme } from '../../theme';

export const medalType = {
  bronze: 'bronze',
  gold: 'gold',
  silver: 'silver',
  trophy: 'trophy',
  platinum: 'platinum',
} as const;

export type MedalType = keyof typeof medalType;

export type MedalProps = {
  type?: MedalType;
  icon?: SvgComponent;
  iconOnClick?: () => void;
};

const Wrapper = styled.div`
  display: flex;
  svg {
    fill: ${theme.colors.primary.white};
    width: 50px;
    max-height: 48px;
    padding-left: 3px;
    cursor: pointer;
  }
`;
export const Medal: React.FC<MedalProps> = ({
  type,
  iconOnClick,
  ...props
}) => {
  const handleOnClick = (e: MouseEvent<SVGSVGElement>) => {
    e.stopPropagation();
    iconOnClick && iconOnClick();
  };
  return (
    <Wrapper {...props}>
      <MedalGoldIcon onClick={handleOnClick} />
    </Wrapper>
  );
};
